import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PageDescription from '@components/PageDescription.js'
import Sessions from '@components/Orientation/Sessions.js'

export const query = graphql`
    query LegislatorOrientationQuery($uid: String) {
        prismic {
            allLegislator_orientations(uid: $uid) {
                edges {
                    node {
                        _meta {
                           uid
                           type
                       }
                        page_title
                        page_description
                        year_range
                        orientation_sessions {
                            orientation_session_title
                            orientation_session_date
                            orientation_session_contents
                            related_content {
                                ...on PRISMIC_Content {
                                title
                                    _meta {
                                        uid
                                        id
                                        type
                                    }
                                }
                            }
                    }
                }
            }
        }
    }
}
`

export default (props) => { 
    const doc = props.data.prismic.allLegislator_orientations.edges.slice(0,1).pop();

    if(!doc) return null;

    if (typeof window !== "undefined"){
        return(
            <Layout>
                <SEO title={doc.node.page_title}  pathname={props.location.pathname}/>
                <Row>
                    <Col>
                        <h1 className="pb-2">{doc.node.page_title}</h1>
                        <hr/>
                        <div>
                            <PageDescription description={doc.node.page_description}/>
                        </div>
                    </Col>
                </Row>
                <hr className="my-4"/>
                <Row>
                    <Col>
                        <Sessions sessions={doc.node.orientation_sessions}/>
                    </Col>
                </Row>
            </Layout>
        )
    }
    else return null;
}